import { F } from 'ramda';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import debounce from 'lodash/debounce';

const fireResizeEventOnWindow = () => window.dispatchEvent(new Event('resize'));

class AutoHeight extends Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 50,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);
    this.observer = new MutationObserver(() => {
      this.updateHeight();
    });
    const observerConfig = {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
    };

    this.observer.observe(this.wrapper, observerConfig);
    this.updateHeight();
  }

  componentDidUpdate() {
    setTimeout(() => this.updateHeight() && fireResizeEventOnWindow()); // Wait things to settle before updating height
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize = debounce(() => this.updateHeight(), 150);

  updateHeight() {
    if (!this.wrapper || this.state.height === this.wrapper.clientHeight) return false;
    this.setState({ height: this.wrapper.clientHeight }, () => { this.forceReflow(); });
    return true;
  }

  forceReflow() {
    this.wrapper.style.height = 0;
    F(this.wrapper.offsetHeight);
    this.wrapper.style.height = '';
  }

  render() {
    if (!this.props.children) return null;
    return (
      <div
        className="c-autoheight"
        style={{ height: this.state.height }}
      >
        <div ref={(ref) => { this.wrapper = ref; this.updateHeight(); }}>
          { this.props.children }
        </div>
      </div>
    );
  }
}
AutoHeight.propTypes = {
  children: PropTypes.node,
};
AutoHeight.defaultProps = {
  children: null,
};

export default AutoHeight;
